import { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

const navItems = [
  { label: '首页', to: '/' },
  { label: '剧情介绍', to: '/category/plot' },
  { label: '演员列表', to: '/category/cast' },
  { label: '推荐专题', to: '/special/recommend' },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/category/plot?q=${encodeURIComponent(q)}`);
    setMenuOpen(false);
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur border-background-200 shadow-[0_1px_0_oklch(var(--background-200))]'
          : 'bg-background-50 border-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6 h-16 md:h-20 flex items-center gap-3 md:gap-6">
        <NavLink to="/" className="flex items-center gap-2.5 shrink-0">
          <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-film-line text-xl"></i>
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading font-bold text-foreground-950 text-base md:text-lg whitespace-nowrap">
              善良的小姨子
            </span>
            <span className="text-[10px] md:text-[11px] text-foreground-500 tracking-widest">
              DRAMA PORTAL
            </span>
          </span>
        </NavLink>

        <nav className="hidden lg:flex items-center gap-1 ml-4">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                  isActive
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form
          onSubmit={handleSearch}
          className="hidden md:flex items-center flex-1 max-w-xs ml-auto bg-background-100 border border-background-200 rounded-full px-3.5 h-10 focus-within:border-accent-400 transition-colors"
        >
          <i className="ri-search-line text-foreground-500 text-base w-5 h-5 flex items-center justify-center"></i>
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索剧集或演员"
            className="flex-1 bg-transparent border-0 outline-none text-sm text-foreground-900 placeholder:text-foreground-400 px-2"
          />
          <button
            type="submit"
            className="text-xs text-accent-700 font-medium whitespace-nowrap hover:text-accent-600 cursor-pointer"
          >
            搜索
          </button>
        </form>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="lg:hidden ml-auto w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
        >
          <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-4 animate-slide-fade">
          <form
            onSubmit={handleSearch}
            className="flex items-center bg-background-100 border border-background-200 rounded-full px-3.5 h-11 mb-4"
          >
            <i className="ri-search-line text-foreground-500 text-base w-5 h-5 flex items-center justify-center"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索剧集或演员"
              className="flex-1 bg-transparent border-0 outline-none text-sm px-2 text-foreground-900 placeholder:text-foreground-400"
            />
            <button type="submit" className="text-xs text-accent-700 font-medium cursor-pointer">
              搜索
            </button>
          </form>
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-md text-sm font-medium ${
                    isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}